import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useOrder } from '../context/OrderContext';
import { User, Phone, MapPin, CheckCircle, ArrowRight } from 'lucide-react';

const Confirmation = () => {
  const { cartItems, cartTotal } = useCart();
  const { saveOrderData } = useOrder();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    fullName: '',
    mobile: '',
    address: ''
  });

  const [errors, setErrors] = useState({});

  const validate = () => {
    let newErrors = {};
    if (!formData.fullName.trim()) newErrors.fullName = 'Full Name is required.';

    const phoneRegex = /^[0-9]{10}$/;
    if (!formData.mobile.trim()) {
      newErrors.mobile = 'Mobile Number is required.';
    } else if (!phoneRegex.test(formData.mobile)) {
      newErrors.mobile = 'Enter a valid 10-digit mobile number.';
    }

    if (!formData.address.trim()) {
      newErrors.address = 'Delivery Address is required.';
    } else if (formData.address.trim().length < 10) {
      newErrors.address = 'Please provide a more detailed address.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      saveOrderData({
        customer: formData,
        items: cartItems,
        totalAmount: cartTotal
      });
      navigate('/payment');
    }
  };

  if (cartItems.length === 0) {
    navigate('/cart');
    return null;
  }

  return (
    <div className="animate-slide-up checkout-grid" style={{ maxWidth: '1000px', margin: '0 auto' }}>

      {/* Delivery Details Form */}
      <div className="white-card" style={{ padding: '2.5rem' }}>
        <h2 style={{ marginBottom: '2rem', display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          <CheckCircle className="text-gradient" /> Order Confirmation
        </h2>

        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label>Full Name</label>
            <div style={{ position: 'relative' }}>
              <User size={20} style={{ position: 'absolute', top: '50%', transform: 'translateY(-50%)', left: '1rem', color: 'var(--text-muted)' }} />
              <input
                type="text"
                className="input-field"
                style={{ width: '100%', paddingLeft: '3rem' }}
                placeholder="John Doe"
                value={formData.fullName}
                onChange={e => setFormData({ ...formData, fullName: e.target.value })}
              />
            </div>
            {errors.fullName && <span className="error-text">{errors.fullName}</span>}
          </div>

          <div className="input-group">
            <label>Mobile Number</label>
            <div style={{ position: 'relative' }}>
              <Phone size={20} style={{ position: 'absolute', top: '50%', transform: 'translateY(-50%)', left: '1rem', color: 'var(--text-muted)' }} />
              <input
                type="tel"
                className="input-field"
                style={{ width: '100%', paddingLeft: '3rem' }}
                placeholder="1234567890"
                value={formData.mobile}
                onChange={e => setFormData({ ...formData, mobile: e.target.value })}
              />
            </div>
            {errors.mobile && <span className="error-text">{errors.mobile}</span>}
          </div>

          <div className="input-group">
            <label>Delivery Address</label>
            <div style={{ position: 'relative' }}>
              <MapPin size={20} style={{ position: 'absolute', top: '1rem', left: '1rem', color: 'var(--text-muted)' }} />
              <textarea
                className="input-field"
                style={{ width: '100%', paddingLeft: '3rem', minHeight: '100px', resize: 'vertical' }}
                placeholder="123 Tech Avenue, Silicon Valley, CA 94025"
                value={formData.address}
                onChange={e => setFormData({ ...formData, address: e.target.value })}
              />
            </div>
            {errors.address && <span className="error-text">{errors.address}</span>}
          </div>

          <button type="submit" className="btn btn-primary" style={{ width: '100%', marginTop: '1rem', justifyContent: 'center' }}>
            Proceed to Payment <ArrowRight size={18} />
          </button>
        </form>
      </div>

      {/* Mini Order Summary */}
      <div className="white-card" style={{ padding: '2rem', position: 'sticky', top: '6rem' }}>
        <h3 className="heading-14" style={{ marginBottom: '1.5rem' }}>Summary</h3>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginBottom: '1.5rem', maxHeight: '300px', overflowY: 'auto' }}>
          {cartItems.map(item => (
            <div key={item.id} style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
              <img src={item.image} alt={item.name} style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '8px' }} />
              <div style={{ flex: 1, fontSize: '0.9rem' }}>
                <div style={{ fontWeight: '600' }}>{item.name}</div>
                <div style={{ color: 'var(--text-muted)' }}>Qty: {item.quantity}</div>
              </div>
              <div style={{ fontWeight: '700' }}>${(item.price * item.quantity).toFixed(2)}</div>
            </div>
          ))}
        </div>

        <div style={{ borderTop: '1px solid var(--glass-border)', paddingTop: '1.5rem', display: 'flex', justifyContent: 'space-between', fontSize: '1.25rem', fontWeight: '700' }}>
          <span>Total To Pay</span>
          <span className="text-gradient">${cartTotal.toFixed(2)}</span>
        </div>
      </div>

    </div>
  );
};

export default Confirmation;
